import { render, staticRenderFns } from "./AppModalsContainer.vue?vue&type=template&id=5a6f48d7&"
import script from "./AppModalsContainer.vue?vue&type=script&lang=js&"
export * from "./AppModalsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports